import React from 'react';
import './Code.css';

const Code = () => {
  return (
    <div className="wrapper">
      <header data-fls-header-login="" data-fls-header-scroll="" className="header-login">
        <div className="header-login__container">
          <div className="header-login__body">
            <a href="/" className="header-login__logo">
              <img src="/assets/img/logo.svg" alt="Logo" />
            </a>
          </div>
        </div>
      </header>
      <main className="page auth">
        <div className="auth__container">
          <div data-fls-block="" className="auth__body code">
            <a href="/login" className="code__back code__back--icon-arrow">
              <span>Указать другой номер</span>
            </a>
            <div className="code__content">
              <h4 className="code__title code__title--title-20">Введите код из уведомления</h4>
              <div className="code__label">Отправили на +7*****9999</div>
              <div className="code__inputs">
                <input autoFocus type="text" maxLength="1" />
                <input type="text" maxLength="1" />
                <input type="text" maxLength="1" />
                <input type="text" maxLength="1" />
              </div>
              <a href="/account" className="code__timer">Запросить новый код можно через 01:24</a>
            </div>
            <a href="#" className="code__error">Не получил код</a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Code;